import { defer, Outlet, RouteObject } from "react-router-dom";
import DPCRoute from "./dpc";
import SanteRoute from "./sante";
import GeneralisteRoute from "./generaliste";
import EdumiamRoute from "./edumiam";
import AlternanceRoute from "./alternance";
import { DataService } from "@/services/data";
import PicklistRoute from "./picklist";
import LMSRoute from "./lms";
import { ShowcaseProductData } from "@/types/content/showcase_product";

const ContentRoute: RouteObject = {
    path: "catalogue",
    element: <Outlet />,
    children: [
        {
            index: true,
            async lazy() {
                let { CataloguePage } = await import("@/pages/content/index");
                return { Component: CataloguePage };
            },
            loader: async ({ request }) => {
                const url = new URL(request.url);
                url.searchParams.set("is_active", "1");
                url.searchParams.set("_send_to_sf", "1");
                if (!url.searchParams.has("page_size")) {
                    url.searchParams.set("page_size", "10");
                }
                const products = await DataService.client
                    .url(`/content/products/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json();
                return defer({ products });
            }
        },
        {
            path: "showcase/:product_id",
            loader: async ({ params }): Promise<{ showcase: ShowcaseProductData | null }> => {
                try {
                    const showcase = (await DataService.client
                        .url(`/content/products/${params.product_id}/showcase/`)
                        .get()
                        .json()) as ShowcaseProductData;
                    return { showcase };
                } catch {
                    return { showcase: null };
                }
            },
        },
        DPCRoute,
        SanteRoute,
        GeneralisteRoute,
        EdumiamRoute,
        AlternanceRoute,
        PicklistRoute,
        LMSRoute
    ]
};
export default ContentRoute;
